import { getFromLocalStorage } from 'global/utils/storage';
import { LAST_REQUEST_ID } from 'config/constant';
import { isNullOrUndefined } from 'global/utils/common';

export const RoutesSettings = {
  attachDocuments: '/attach-documents',
  auth: '/usuario/login/:ticket',
  getRequestDetailUrl: () => {
    const ppu = getFromLocalStorage(LAST_REQUEST_ID);

    if (isNullOrUndefined(ppu)) {
      return RoutesSettings.home;
    }

    return `/vehiculos/control_vehicular/u/${ppu}`;
  },
  home: '/',
  signIn: '/sign-in',
  signUp: '/sign-up',
  vehicleDocument: '/vehicle-documents',
  vehicleDocuments: '/vehicle-documents/:id',
  vehicularCheckPoint: '/vehiculos/control_vehicular/u/:id',
};

export default RoutesSettings;
